import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { User } from "../../_models/user";
import { Router, ActivatedRoute } from "@angular/router";
import { Globals } from "../../_models/globals";
import { AlertService } from '../../_services/alert.service';
import * as moment from 'moment';
import { ApiIntegration } from '../../_services/api.integration';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-create-google-sheet',
  templateUrl: './create-google-sheet.component.html',
  styleUrls: ['./create-google-sheet.component.scss'],
})
export class CreateGoogleSheetComponent implements OnInit {

  channelNameError: string;
  channelName: string;
  googleSheetError: string;
  googleSheetNameError: string;
  googleSheetId: string;
  googleSheetName: string;
  apiKeyError: string;
  apiKey: string;
  instructions: string = 'N';

  constructor(private alertService: AlertService, private api: ApiIntegration, private user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute, public g: Globals) {

  }

  channelNameBlur() {
    this.channelNameError = "";
    if (!this.channelName) {
      this.channelNameError = 'Please enter channel name';
    }
  }

  googleSheetIdBlur() {
    this.googleSheetError = "";
    if (!this.googleSheetId) {
      this.googleSheetError = 'Please enter google sheetId';
    }
  }
  googleSheetNameBlur() {
    this.googleSheetNameError = "";
    if (!this.googleSheetName) {
      this.googleSheetNameError = 'Please enter google sheet Name';
    }
  }

  apiKeyBlur() { }

  showInstructions() {
    this.instructions = 'Y';
  }

  ngOnInit() { }

  verifyGoogleSheet() {


    this.g.loaderDisplay = "display";
    this.channelNameError = "";
    this.googleSheetError = "";

    if (!this.channelName) {
      this.channelNameError = 'Please enter channel name';
    }
    if (!this.googleSheetId) {
      this.googleSheetError = 'Please enter google sheetId';
    }
    if (!this.googleSheetName) {
      this.googleSheetNameError = 'Please enter google sheet Name';
    }

    if (this.channelNameError != "" || this.googleSheetError != "" || this.googleSheetNameError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/google-sheets/validate', {
      "accountOwnerId": this.user.accountOwnerId,
      "connectionName": this.channelName,
      "organizationId": this.user.organizationId,
      "sheetId": this.googleSheetId,
      "sheetName": this.googleSheetName
    },
      { headers: header1 }).subscribe(data => {
        if (data['code'] == "200") {
          this.alertService.success(data['message']);
          this.router.navigate(['/admin/storeIntegrations']);
        } else {
          this.alertService.error(data['message']);
        }
        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }

}
